import {AppMetaData, MetaDataQuery} from 'js/tool/metaData/types';
import {FbAdminMetaData} from 'graphql/generated';
import {AdminMetadataQuery, UserMetadataQuery} from 'js/tool/metaData/__document__/queries';

export function isFbAdminMetaData(test?: MetaDataQuery): test is AdminMetadataQuery {
	if (test && 'fbAdminMetaData' in test) {
		return true;
	}

	return false;
}

export function isFbUsersData(test?: any): test is UserMetadataQuery {
	if (test && 'fbUsers' in test) {
		return true;
	}

	return false;
}

export function isFbUsersMetaData(test?: FbAdminMetaData | AppMetaData): test is AppMetaData {
	return !!(test && 'selectedCustomer' in test);
}
